import db from "../driverappdb";

export const UnproductiveTimeRepository = {
    getUnproductiveTimes: async (routeId) => {
        return db.unproductivetimes.where({ routeId: routeId }).toArray();
    }
};